import uuidv4 from 'uuid/v4';

/**
 * Attributes that never follow a copy. `alternativeName` is a per-project
 * cost-tracking label (see scenes/ExpenseTracking/utils/assignmentDisplayName).
 * The backend copy utilities (child / shadow project cascades, reactive
 * lambda) apply the same exclusion.
 */
const NOT_COPIED = ['alternativeName'];

/**
 * Copies assignments to another project with fresh ids, remapping `parent`
 * within the batch and marking each copy with `copiedFrom`.
 * Everything else (budgets, talseComment, completion, hideIn*, createdAt, …)
 * is copied as-is; a parent outside the batch stays unmapped (undefined).
 * @param {Array<object>} assignments
 * @param {string} projectId - target project id
 * @returns {Array<object>}
 */
export default function copyAssignments(assignments, projectId) {
  const idMapping = {};
  assignments.forEach((a) => {
    idMapping[a.id] = uuidv4();
  });

  return assignments.map((a) => {
    const copy = {
      ...a,
      id: idMapping[a.id],
      copiedFrom: a.id,
      parent: a.parent ? idMapping[a.parent] : null,
      project: projectId,
    };
    NOT_COPIED.forEach((key) => delete copy[key]);
    return copy;
  });
}
